<template>
  <v-dialog
    v-bind="$attrs"
    v-on="$listeners"
    overlay-color="black"
    overlay-opacity="0.75"
    class="dialog-modal-premium"
    style="border: 2px solid white;"
    :width="tamañoModal"
  >
    <v-card class="dialog-modal-premium__card" width="100%">
      <v-col class="d-flex flex-column pt-0" cols="12">
        <v-row class="dialog-modal-premium__title-container py-10 px-10" justify="center">
          <div class="dialog-modal-premium__title-style-container d-flex justify-space-between">
            <p class="dialog-modal-premium__title-style mb-5">¿Deseas acceder a nuestro contenido premium?</p>
            <v-img
              src="@/assets/modalPremium/modalCaracter.svg"
              max-width="104"
              max-height="299"
              class="dialog-modal-premium__image-header d-xs-flex d-sm-flex d-md-none"
            />
          </div>
        </v-row>
        <v-row class="d-flex flex-row py-10 align-self-center">
          <div class="d-flex flex-column align-center">
            <div v-for="message in messages" :key="message.id" class="dialog-modal-premium__benefits d-flex pb-2">
              <v-img
                src="@/assets/icon/checkModalPremium.svg" class="dialog-modal-premium__check pr-15"
                height="12.96"
                max-width="17.91"
                contain
              />
              <p class="dialog-modal-premium__message-style">{{ message.descripcion }}</p>
            </div>
          </div>
          <v-img
            src="@/assets/modalPremium/modalCaracter.svg"
            max-width="104"
            max-height="299"
            class="dialog-modal-premium__image d-none d-md-flex d-lg-flex"
          />
        </v-row>
        <v-row class="d-flex justify-center mb-5">
          <div class="dialog-modal-premium__button d-flex justify-center">
            <boton-usamedic width="75%" @click="convertToPremium">¡Quiero ser Premium!</boton-usamedic>
          </div>
        </v-row>
      </v-col>
    </v-card>
  </v-dialog>
</template>

<script>
import BotonUsamedic from '@/components/BotonUsamedic'
import { mapActions, mapState } from 'vuex'

export default {
  components: { BotonUsamedic },
  props: {},
  data () {
    return {
      messages: []
    }
  },
  computed: {
    ...mapState('perfil', ['user']),
    tamañoModal () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return '90%'
        case 'sm':
          return '80%'
        case 'md':
          return '60%'
        case 'lg':
          return '50%'
        case 'xl':
          return '35%'
        default:
          return '50%'
      }
    }
  },
  methods: {
    ...mapActions('perfil', ['fetchUser']),
    async fetchMessages () {
      const messageRespose = await this.$http.get('api/permisos/')
      this.messages = messageRespose.data
    },
    async convertToPremium () {
      // let message = 'Se ha convertido en un usuario premium.'
      // try {
      //   await this.$http.post('api/permisos/ser_premium/')
      //   await this.fetchUser()
      // } catch (e) {
      //   message = e.response.data[0]
      // } finally {
      //   await this.$root.$confirm({
      //     message,
      //     acceptText: 'Aceptar'
      //   })
      //   this.$emit('aceptar')
      // }
      if (this.user.is_premium) {
        this.$root.$confirm({
          title: 'Buenas noticias!',
          message: 'Tu ya cuentas con una membresia premium, estamos trabajando para darte nuevas funcionalidades'
        })
      } else {
        this.$root.$confirm({
          title: 'UPS!',
          message: 'Pronto podrás ser premium. Si eres alumno de algún curso, comunicate con Usamedic'
        })
      }
      // alert('Paga, perro.')
    }
  },
  mounted () {
    this.fetchMessages()
  }
}
</script>

<style lang="scss" scoped>
.dialog-modal-premium {
  border-radius: 20px !important;

  &__card {
    border-radius: 20px !important;
  }

  &__benefits {
    width: 90%;
  }

  &__title-container {
    background: linear-gradient(90deg, rgba(31, 193, 208, 1), rgba(5, 131, 218, 1));
    border-radius: 20px;
    height: 152px;
    overflow: hidden;
  }

  &__title-style-container {
    width: 100%;
  }

  &__title-style {
    font-size: 20px;
    font-weight: 600;
    color: white;
    width: 100%;
  }

  &__message-style {
    font-size: 13px;
    font-weight: 400;
    width: 100%;
  }

  &__check {
    width: 17.91px !important;
  }

  &__button {
    width: 100%;
  }

  &__image {
    margin-top: -24%;
  }
}

@media (min-width: 960px) {
  .dialog-modal-premium__title-style-container {
    width: 70%;
  }
}

@media (min-width: 700px) {
  .dialog-modal-premium__title-style-container {
    width: 70%;
  }
}

@media (max-width: 700px) {
  .dialog-modal-premium__image {
    position: absolute;
    margin-top: -30%;
    margin-left: 350px;
    overflow: hidden;
  }
  .dialog-modal-premium__title-style-container {
    width: 90%;
    margin-top: 0%;
  }
}

@media (max-width: 460px) {
  .dialog-modal-premium__title-container {
    height: 216px;
  }
  .dialog-modal-premium__image-header {
    margin-top: 16%;
    position: relative;
  }
}

@media (max-width: 400px) {
  .dialog-modal-premium__title-container {
    height: 216px;
  }
  .dialog-modal-premium__image-header {
    margin-top: 0;
    position: relative;
  }
  .dialog-modal-premium__title-style-container {
    width: 100%;
  }
}

@media (max-width: 281px) {
  .dialog-modal-premium__image-header {
    visibility: hidden;
    display: none;
  }
}
</style>
